/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Passkey_AddedInputs */

const en_passkey_added = /** @type {(inputs: Passkey_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.date}`)
};

const de_passkey_added = /** @type {(inputs: Passkey_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hinzugefügt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Added {date}" |
*
* @param {Passkey_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_added = /** @type {((inputs: Passkey_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_added(inputs)
	return en_passkey_added(inputs)
});